import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { GetEnterpriseSubscriptions, } from "../../services/ReasonService";
import { GetUtilitiesCorreosIdEnterpriseServices, } from "../../services/UtilitiesCallsService";
import { CircularProgress } from "@material-ui/core";
import { ServiceList } from "..//ServiceList/ServiceList";
import { checkIsNullUndefined, getErrorMessage } from "../../commons/Utils";
import { Alerts } from "../Alerts/Alerts";
import { useTranslation } from "react-i18next";
import { DialogSubscribeOk } from "../CommonComponents/Dialogs/DialogSubscribeOk";

export function EnterpriseServices(props) {
  const { setUpdateEnterprises, idEnterprise, getIsOrganization, getIsTitular } = props;
  const { t } = useTranslation();

  const [isTitular, setIsTitular] = useState(false);
  const [circularProgress, setCircularProgress] = useState(true);
  const [serviceList, setServiceList] = useState([]);
  const [enterpriseServices, setEntServices] = useState([]);
  const [openSubOk, setOpenSubOk] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    color: "",
    message: "",
  });

  useEffect(() => {
    setIsTitular(getIsTitular() && !getIsOrganization());
    getServices();
  }, [idEnterprise]);

  const finishOperation = (color, message) => {
    setAlert({
      open: true,
      color,
      message,
    });
  };

  const getServices = () => {
    setCircularProgress(true);
    GetUtilitiesCorreosIdEnterpriseServices().then((response) => {
      if (response && !response.Status) {
        setServiceList(response);
        getSubscriptions();
      } else {
        //Alerta
        finishOperation("error", getErrorMessage(response, t));
        setCircularProgress(false);
      }
    });
  };

  const getSubscriptions = (subscription) => {
    setCircularProgress(true);
    GetEnterpriseSubscriptions(idEnterprise).then((response) => {
      if (response && !response.Status) {
        setEntServices(response);
        if (!checkIsNullUndefined(subscription)) {
          if (subscription) {
            setOpenSubOk(true);
          } else {
            finishOperation("success", t("serviceUnsubscribed"));
          };
        };
        setCircularProgress(false);
      } else {
        //Alerta
        finishOperation("error", getErrorMessage(response, t));
        setCircularProgress(false);
      }
    });
  };

  const resetPageData = (subscribed) => {
    getSubscriptions(subscribed);
  };

  return (
    <Grid>
      <Alerts alert={alert} setAlert={setAlert}></Alerts>
      <Grid>
        <DialogSubscribeOk
          open={openSubOk}
          setOpen={setOpenSubOk}
        />
        {circularProgress ? (
          <CircularProgress />
        ) : (
          <ServiceList
            serviceList={serviceList}
            idEnterprise={idEnterprise}
            subscribedServices={enterpriseServices}
            isTitular={isTitular}
            finishOperation={finishOperation}
            resetPageData={resetPageData}
            setUpdateEnterprises={setUpdateEnterprises}
          />
        )}
      </Grid>
    </Grid>
  );
}
